// extracted by mini-css-extract-plugin
export var content = "_88-1";
export var modal = "_88-0";